// react components
import React from 'react'

// serializers
import {
    ContentTypeFieldTypes,
} from 'serializers/site'

// props
type DetailRow825Props = {
    children?: React.ReactNode
    fieldSettings: ContentTypeFieldTypes | undefined
    isError?: boolean
    isRich?: boolean
    rowId: string
    title: string
    value: string
}

// main
export const DetailRow825: React.FC<DetailRow825Props> = React.memo(({
    children,
    fieldSettings,
    isError,
    isRich,
    rowId,
    title,
    value,
}) => {
    return (
        <div className={`detail-component-row ${rowId} ${isRich ? 'RichTextField' : (fieldSettings?.fieldType || 'error')}${isError ? ' error' : ''}`}>
            <p className='dcr-title'>
                <span>{title}</span>
            </p>
            <div className='dcr-value'>
                <div className='dcr-value-wrap'>
                    {children
                        ? <div>{children}</div>
                        : <p>{value}</p>
                    }
                </div>
            </div>
        </div>
    )
})
